var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuReview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 31,
    viewBox: "0 0 26 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5938 1.00049H4.375C3.6125 1.00049 2.88123 1.30339 2.34207 1.84256C1.8029 2.38172 1.5 3.11299 1.5 3.87549V26.8755C1.5 27.638 1.8029 28.3693 2.34207 28.9084C2.88123 29.4476 3.6125 29.7505 4.375 29.7505H21.625C22.3875 29.7505 23.1188 29.4476 23.6579 28.9084C24.1971 28.3693 24.5 27.638 24.5 26.8755V8.90674L16.5938 1.00049Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.125 12.9302C10.4125 12.3552 10.8437 11.7802 11.4187 11.4927C12.0141 11.1486 12.709 11.0179 13.3887 11.1225C14.0683 11.2271 14.6919 11.5605 15.1562 12.0677C15.5875 12.6427 15.875 13.2177 15.875 13.9365C15.875 15.8052 13 16.8115 13 16.8115M13 22.5615H13.0144",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuReview);
export default __webpack_public_path__ + "static/media/menu-review.a0d8d9b558d8648c256a3fc38257f88b.svg";
export { ForwardRef as ReactComponent };